// Importing main React and ReactDOM dependencies for UI handling.
import React from 'react';
import { createRoot } from 'react-dom/client';

// Import functionality for monitoring application performance.
import reportWebVitals from './reportWebVitals';

// Importing global styles for the application.
import './index.scss';

// --- Company config ---
import { companies } from './configs/companies';

const currentCompany = process.env.REACT_APP_COMPANY_MODE || 'default';
const APP_CONFIG = companies[currentCompany as keyof typeof companies];

const applyIconLink = (link: HTMLLinkElement | null, href: string) => {
  if (!link) return;
  link.href = href;
  if (href.endsWith('.svg')) {
    link.type = 'image/svg+xml';
  } else if (href.endsWith('.ico')) {
    link.type = 'image/x-icon';
  } else {
    link.removeAttribute('type');
  }
};

applyIconLink(document.getElementById('favicon') as HTMLLinkElement, APP_CONFIG.favicon);
applyIconLink(document.getElementById('favicon-shortcut') as HTMLLinkElement, APP_CONFIG.favicon);
applyIconLink(document.getElementById('apple-icon') as HTMLLinkElement, APP_CONFIG.appleIcon);
document.title = APP_CONFIG.siteName;

const metaAppName = document.querySelector('meta[name="application-name"]') as HTMLMetaElement;
if (metaAppName) metaAppName.content = APP_CONFIG.siteName;

const metaOgSite = document.querySelector('meta[property="og:site_name"]') as HTMLMetaElement;
if (metaOgSite) metaOgSite.content = APP_CONFIG.siteName;

// Getting a reference to the root DOM element.
const rootElement = document.getElementById('root') as HTMLElement;
// Creating a root React instance to manage the application.
const root = createRoot(rootElement);

const isHealthReportRender =
  window.location.pathname.replace(/\/+$/, '') === '/internal/health-report-render';

if (isHealthReportRender) {
  void import('./views/healthReportRender/HealthReportRenderPage').then(
    ({ default: HealthReportRenderPage }) => {
      root.render(
        <React.StrictMode>
          <HealthReportRenderPage />
        </React.StrictMode>,
      );
    },
  );
} else {
  void import('./bootstrapApp').then(({ renderApp }) => renderApp(root));
}

// Launching the performance monitoring of the application.
reportWebVitals();
